module.exports = __webpack_public_path__ + "img/vertical_7_3_3.92bde5de.png";